import { useState, useEffect } from 'react';
import { getBreakpoint, getGridConfig, type Breakpoint, type GridConfig } from '../types/responsive';

export function useBreakpoint(): Breakpoint {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(() =>
    typeof window !== 'undefined' ? getBreakpoint(window.innerWidth) : 'desktop'
  );

  useEffect(() => {
    const handleResize = () => {
      const newBreakpoint = getBreakpoint(window.innerWidth);
      setBreakpoint((prev) => (prev !== newBreakpoint ? newBreakpoint : prev));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoint;
}

export function useGridConfig(): GridConfig {
  const [config, setConfig] = useState<GridConfig>(() =>
    typeof window !== 'undefined' ? getGridConfig(window.innerWidth) : getGridConfig(1024)
  );

  useEffect(() => {
    const handleResize = () => {
      setConfig(getGridConfig(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return config;
}
